import { api } from '../../api'
import entities from '../../api/entities'
import { endpointSetter } from '../../api/utils'
import {
  ApiParams,
  BlockTrainFileType,
  Railcar,
  RailcarCreateData,
  RailcarFilePayload,
  RailcarUpdatePayload,
} from '../../types'

interface GetByIdResponse {
  railCar: Railcar
}
export interface GetAllByFiltersResponse {
  railCars: {
    railCars: Railcar[]
    total: number
  }
}

interface PostResponse {
  railCar: Railcar
}

interface GetBlockTrainFileTypesResponse {
  railCarFileTypes: BlockTrainFileType[]
}

const entity = entities.railcar
const endpoint = `/${entity}`
const idEnpointSetter = endpointSetter(endpoint)
const bodyProperty = entity

const getAllByFilters = async ({ filters }: ApiParams) => {
  const response = await api.get<GetAllByFiltersResponse>(endpoint, {
    params: filters,
  })

  return response.data.railCars
}

const getById = async (id: number | string) => {
  const response = await api.get<GetByIdResponse>(idEnpointSetter(id))

  return response.data.railCar
}

const post = async ({ payload, files, types }: RailcarCreateData) => {
  const form = new FormData()
  form.append(bodyProperty, JSON.stringify(payload))

  if (!!files?.length && !!types?.length) {
    files.forEach((file, index) => {
      if (file instanceof File) {
        form.append('documentFile', file)
        form.append('fileType', types[index])
      } else {
        throw new Error(`files[${index}] is not a File object`)
      }
    })
  }

  const response = await api.post<PostResponse>(endpoint, form)

  return response.data.railCar
}

const put = async (id: number | string, payload: RailcarUpdatePayload) => {
  const response = await api.put(idEnpointSetter(id), payload)

  return response.data.result
}

const uploadRailcarFile = async (payload: RailcarFilePayload) => {
  const formData = new FormData()
  if (payload.railcarFile instanceof File) {
    formData.append('documentFile', payload.railcarFile)
  } else {
    throw new Error('Is not a File object')
  }
  if (payload.fileTypeId !== undefined) {
    formData.append('fileTypeId', payload.fileTypeId.toString())
  } else {
    throw new Error('fileTypeId is required')
  }

  const response = await api.post(`${endpoint}/${payload.railcarId}/add-file`, formData)
  return response.data
}

const deleteRailcarFile = async (fileId: number | string) => {
  const response = await api.delete(`${endpoint}/file/${fileId}`)
  return response.data
}

const getAllFileTypes = async () => {
  const response = await api.get<GetBlockTrainFileTypesResponse>(`${endpoint}-file-type`)

  return response.data.railCarFileTypes
}

const RailcarApi = {
  getAllByFilters,
  getById,
  post,
  put,
  uploadRailcarFile,
  getAllFileTypes,
  deleteRailcarFile,
}

export default RailcarApi
